'use client';

import React from 'react';
import { StatCardProps } from '@/types';

const badgeColorMap: Record<string, { bg: string; text: string; iconBg: string; iconColor: string }> = {
  blue: { bg: 'bg-blue-100', text: 'text-blue-600', iconBg: 'bg-blue-100', iconColor: 'text-blue-500' },
  pink: { bg: 'bg-pink-100', text: 'text-pink-600', iconBg: 'bg-pink-100', iconColor: 'text-pink-400' },
  yellow: { bg: 'bg-yellow-400', text: 'text-gray-900', iconBg: 'bg-yellow-100', iconColor: 'text-yellow-500' },
  green: { bg: 'bg-green-100', text: 'text-green-600', iconBg: 'bg-green-100', iconColor: 'text-green-500' },
  gray: { bg: 'bg-gray-100', text: 'text-gray-600', iconBg: 'bg-blue-100', iconColor: 'text-blue-500' },
};

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  badge,
  badgeColor,
  icon,
}) => {
  const colors = badgeColorMap[badgeColor];

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 shadow-sm flex flex-col gap-3 md:gap-4 min-w-0">
      <div className="flex items-start justify-between gap-2 min-w-0">
        <div
          className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0 ${colors.iconBg} ${colors.iconColor}`}
        >
          {icon}
        </div>
        {badge && (
          <span
            className={`text-[10px] md:text-xs font-semibold px-2 md:px-3 py-1 rounded-full whitespace-nowrap shrink-0 ${colors.bg} ${colors.text}`}
          >
            {badge}
          </span>
        )}
      </div>
      <div>
        <p className="text-[9px] md:text-xs uppercase tracking-widest text-gray-400 font-semibold">
          {label}
        </p>
        <p className="text-2xl md:text-3xl font-bold text-[#0f1f4b] mt-1 md:mt-2">{value}</p>
      </div>
    </div>
  );
};